import React, {useState, useEffect, memo} from 'react';
import Input from '../../../CoreWrappers/Input';
import styled from 'styled-components';
import {UserLookupType, UserType} from '../../../../util/uiconstants';
import {labels} from '../../../../util/utils';
import UserSearch from '../../../Common/Search/CustomizedUsersearch';

const AddProjectOwner = (props) => {
	const {userLookupType, userError, setUserError, users, setUsers} = props;

	const [userInformation, setUserInformation] = useState({});
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [isDuplicateUser, setIsDuplicateUser] = useState(false);

	useEffect(() => {
		const thisUser = findSelectedUser();
		if (thisUser) {
			setFirstName(thisUser.firstName);
			setLastName(thisUser.lastName);
			setUserInformation(thisUser);
			checkDuplicateUser(thisUser);
		}
	}, [users]);

	const findSelectedUser = () => {
		const thisUser = users.find((el) => el.id === props.id);

		return thisUser;
	};

	const cleanUser = (id, isEmpty) => {
		setUsers(users.filter((x) => x.id !== id));
	};

	const checkDuplicateUser = (thisUser) => {
		let found = false;

		if (thisUser.emailAddress !== '') {
			found = users.filter((el) => el.emailAddress === thisUser.emailAddress).length > 1;
		}

		if (found) {
			setIsDuplicateUser(true);
			setUserError(true);
		} else {
			setIsDuplicateUser(false);
			setUserError(false);
		}

		return found;
	};

	const onUserSelectionChange = (user) => {
		const {firstName, lastName, gui, userType, isInternal} = user.allProps;
		setUserInformation(user.allProps);
		setFirstName(firstName);
		setLastName(lastName);
		setSelectedMember(user);
	};

	const setSelectedMember = (user) => {
		const {gui, userType, isInternal, firstName, lastName} = user.allProps;
		let payload = {
			id: props.id,
			firstName: firstName,
			lastName: lastName,
			emailAddress: user.value,
			roles: [],
			userId: gui ? gui : user.value,
			isInternal: isInternal || userType === UserType.Member,
			isEmpty: false
		};

		setUsers([...users, payload]);
		if (props.setSelectedMember) {
			props.setSelectedMember(payload);
		}
	};

	const resetInputValues = () => {
		setUserInformation({});
	};

	const onUserClear = () => {
		setFirstName('');
		setLastName('');
		resetInputValues();
		setUserError(true);
	};

	useEffect(() => {
		if (props.clearData) {
			onUserClear();
		}
	}, [props.clearData]);

	return (
		<StyledProjectOwner className={props.className} id={props.id}>
			<section className="search-box-wrapper">
				<UserSearch
					// TODO: Add proper label
					key={props.id}
					id={props.id}
					showValidations={userError && (_.isEmpty(userInformation) || userInformation.isEmpty || isDuplicateUser)}
					onUserClear={onUserClear}
					onUserSelectionChange={onUserSelectionChange}
					lookupType={userLookupType || UserLookupType.NotSpecified}
					userError={userError && (_.isEmpty(userInformation) || userInformation.isEmpty || isDuplicateUser)}
					isNewAdd={props.isNewAdd}
					maxSearchLength={100}
					user={{}}
					isDisabled={props.isDisabled}
					clearUserData={props.clearData}
					canClearSelectedValue={props.canClearSelectedValue}
					isDuplicateUser={isDuplicateUser}
					duplicateUserMessage={labels.duplicateOwnerAdded}
					hideClearIcon={props.hideClearIcon}
					findSelectedUser={findSelectedUser}
					cleanUser={cleanUser}
					showErrorOnClear={true}
				/>
			</section>
			<div className="group-input-textbox">
				<Input
					label={labels.firstName}
					id={'firstname_' + props.id}
					maxLength="100"
					value={firstName}
					disabled={!props.isNameEditable}
					onInputChange={() => {}}
				/>
			</div>
			<div className="group-input-textbox">
				<Input
					label={labels.lastName}
					id={'lastname' + props.id}
					maxLength="100"
					value={lastName}
					disabled={!props.isNameEditable}
					onInputChange={() => {}}
				/>
			</div>
		</StyledProjectOwner>
	);
};

export const AddProjectOwnerMemoized = memo(AddProjectOwner);

export default AddProjectOwnerMemoized;

const StyledProjectOwner = styled.section`
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin: 2rem -1rem 3rem;
	min-height: 5rem;
	.user-selectbox {
		display: inline-block;
		width: 100%;
		.SelectDropdownContainer {
			.react-select-label {
				top: unset;
			}
		}
	}
	.search-box-wrapper {
		max-height: 5rem;
		padding-bottom: 1rem;
		width: 24rem;

		.enterdetail-description {
			bottom: 0;
			margin-top: 0.5rem;
		}
	}
	.search-box-wrapper,
	.group-input-textbox,
	.clearall {
		flex-grow: 1;
		margin: 0 0.5rem;
	}
	.clearall {
		margin-top: 1.3rem;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
	.group-input-textbox {
		width: 10rem;
	}
	.motif-input-component {
		width: 100%;
	}
`;
